export default __webpack_public_path__ + "static/media/partnerImg2.e7e9e3ad.png";